function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_18604",
  "data-name": "Group 18604",
  transform: "translate(-907.491 -256.359)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_16942",
  "data-name": "Group 16942",
  transform: "translate(989.106 256.359)",
  opacity: 0.294
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_16960",
  "data-name": "Group 16960",
  transform: "translate(907.491 311.677)",
  opacity: 0.19
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518-2",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519-2",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2778",
  "data-name": "Ellipse 2778",
  transform: "translate(1037.698 334.313)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.16
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2779",
  "data-name": "Ellipse 2779",
  transform: "translate(1036.568 276.574)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.17
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2780",
  "data-name": "Ellipse 2780",
  transform: "translate(923.026 328.184)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.294
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_17279",
  "data-name": "Group 17279",
  transform: "translate(939.284 280.395)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_17278",
  "data-name": "Group 17278",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3503",
  "data-name": "Group 3503",
  opacity: 0.996
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5369",
  "data-name": "Path 5369",
  d: "M239.557,724.816v2.867H205.886V671.839h33.671v24.1h2.386V670.458a1.3,1.3,0,0,0-1.193-1.382H204.693a1.3,1.3,0,0,0-1.193,1.382v58.608a1.3,1.3,0,0,0,1.193,1.382h36.058a1.3,1.3,0,0,0,1.193-1.382v-4.249h-2.386Z",
  transform: "translate(-203.5 -669.076)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5370",
  "data-name": "Path 5370",
  d: "M221.622,680.681h-8.651a1.193,1.193,0,0,1,0-2.386h8.651a1.193,1.193,0,0,1,0,2.386Z",
  transform: "translate(-205.945 -671.799)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5371",
  "data-name": "Path 5371",
  d: "M237.363,688.583H212.971a1.193,1.193,0,0,1,0-2.386h24.392a1.193,1.193,0,0,1,0,2.386Z",
  transform: "translate(-205.945 -672.137)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5372",
  "data-name": "Path 5372",
  d: "M237.363,696.485H212.971a1.193,1.193,0,1,1,0-2.386h24.392a1.193,1.193,0,1,1,0,2.386Z",
  transform: "translate(-205.945 -673.55)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5373",
  "data-name": "Path 5373",
  d: "M229.426,704.388H214.06c-1.262,0-2.282-.535-2.282-1.193S212.8,702,214.06,702h15.366c1.262,0,2.282.535,2.282,1.193S230.688,704.388,229.426,704.388Z",
  transform: "translate(-205.945 -674.962)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5374",
  "data-name": "Path 5374",
  d: "M221,712.29h-8.031a1.193,1.193,0,1,1,0-2.386H221a1.193,1.193,0,0,1,0,2.386Z",
  transform: "translate(-205.945 -676.375)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5375",
  "data-name": "Path 5375",
  d: "M221,720.192h-8.031a1.193,1.193,0,1,1,0-2.386H221a1.193,1.193,0,0,1,0,2.386Z",
  transform: "translate(-205.945 -677.788)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5376",
  "data-name": "Path 5376",
  d: "M221,728.094h-8.031a1.193,1.193,0,1,1,0-2.385H221a1.193,1.193,0,1,1,0,2.385Z",
  transform: "translate(-205.945 -679.201)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31241",
  "data-name": "Path 31241",
  d: "M221,728.094h-8.031a1.193,1.193,0,1,1,0-2.385H221a1.193,1.193,0,1,1,0,2.385Z",
  transform: "translate(-205.945 -673.083)",
  fill: "#8c9cac"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_18603",
  "data-name": "Group 18603",
  transform: "translate(976.493 281.643)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18544",
  "data-name": "Group 18544",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18071",
  "data-name": "Group 18071",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18062",
  "data-name": "Group 18062"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18053",
  "data-name": "Group 18053"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_171",
  "data-name": "Subtraction 171",
  d: "M3.345,42.719h0C2.112,42.622,1.009,41.206,0,39.69V38.451a11.717,11.717,0,0,1,11.7-11.7H21.734A11.7,11.7,0,0,1,31.4,31.857a20.281,20.281,0,0,0-4-.4c-.31,0-.65.016-1.011.047a8.314,8.314,0,0,0-4.652-1.413H11.7a8.368,8.368,0,0,0-8.359,8.359v4.267ZM16.718,23.406A11.7,11.7,0,1,1,28.423,11.7,11.715,11.715,0,0,1,16.718,23.406Zm0-20.062A8.359,8.359,0,1,0,25.076,11.7,8.368,8.368,0,0,0,16.718,3.344Z",
  fill: "#8c9cac"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "image-gallery-line",
  transform: "translate(4.833 35.032)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31203",
  "data-name": "Path 31203",
  d: "M41.169,10H6.345a2.318,2.318,0,0,0-2.318,2.318v6.949L0,23.3l4.027,3.65v7.86a2.318,2.318,0,0,0,2.318,2.318H41.169a2.318,2.318,0,0,0,2.318-2.318V12.318A2.318,2.318,0,0,0,41.169,10Zm-.148,24.663H6.493V26.3L2.466,23.059l4.027-3.742v-6.85H41.021Z",
  transform: "translate(0 -10)",
  fill: "#f3994e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31209",
  "data-name": "Path 31209",
  d: "M2.608,1.5A1.921,1.921,0,0,1,4.565-.687,1.927,1.927,0,0,1,6.522,1.5,1.929,1.929,0,0,1,4.565,3.674,1.923,1.923,0,0,1,2.608,1.5Zm6.318,0A4.255,4.255,0,0,0,4.565-2.861,4.272,4.272,0,0,0,.192,1.5,4.282,4.282,0,0,0,4.565,5.873,4.482,4.482,0,0,0,5.374,5.8l.942,1.413H9.143l-1.8-2.3A4.3,4.3,0,0,0,8.926,1.5Zm.242,6.62h2.283L14.676-5.712H12.393ZM20.994,5.788h2.5L20.4-2.728h-2.73l-3.1,8.516h2.488L17.515,4.4h3.02Zm-1.051-3.2H18.119l.906-2.754Z",
  transform: "translate(11.469 12.028)",
  fill: "#f3994e"
}))), /*#__PURE__*/React.createElement("line", {
  id: "Line_2216",
  "data-name": "Line 2216",
  x2: 31.609,
  transform: "translate(1019.775 297.921)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2217",
  "data-name": "Line 2217",
  x2: 33.988,
  transform: "translate(1019.435 307.437)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
}));

function SvgSurveyRespond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.933,
    height: 87.446,
    viewBox: "0 0 145.933 87.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyRespond);
export default __webpack_public_path__ + "static/media/surveyRespond.c9d0cba5.svg";
export { ForwardRef as ReactComponent };